import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { HTTP_INTERCEPTORS, provideHttpClient, withFetch, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { provideTranslateService } from '@ngx-translate/core';

import { routes } from './app.routes';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { ru_RU, provideNzI18n } from 'ng-zorro-antd/i18n';
import { provideNzIcons } from 'ng-zorro-antd/icon';
import { FormOutline, HistoryOutline, ManOutline, WomanOutline } from '@ant-design/icons-angular/icons';
import { registerLocaleData } from '@angular/common';
import ru from '@angular/common/locales/ru';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { httpTokenInterceptor } from './interceptors/http.interceptor';
import { AuthExpiredInterceptor } from './auth-expired.interceptor';
import { TokenInterceptor } from './token.interceptor';

registerLocaleData(ru);

export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimations(),
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes, withInMemoryScrolling({
      scrollPositionRestoration: 'top',
      anchorScrolling: 'enabled'
    })),
    provideClientHydration(withEventReplay()),
    // withFetch: на сервере HttpClient иначе тянет полифилл xhr2, а тот
    // зовёт устаревший url.parse() — Node 24 ругается DEP0169.
    provideHttpClient(
      withFetch(),
      withInterceptors([httpTokenInterceptor])
    ),
    provideTranslateService({
      defaultLanguage: 'ru',
      loader: provideTranslateHttpLoader({
        prefix: '/i18n/',
        suffix: '.json'
      })
    }), 
    provideNzI18n(ru_RU),
    // Иконки вне дефолтного набора ng-zorro. Без регистрации они подгружаются
    // запросом за SVG, а на сервере такого запроса нет — SSR падает в ошибку.
    provideNzIcons([HistoryOutline, FormOutline, ManOutline, WomanOutline]),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptorsFromDi()),
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AuthExpiredInterceptor, multi: true },
  ]
};
